<template>
  <div class="p-4">
    <h4>{{ chartRoute.title }}</h4>
    <p>The investigation shows how U.S. trusts have become a go-to vehicle for financial secrecy.</p>
    <stacked-bar-chart
      :data="$options.tsv"
      :fixed-height="fixedHeight"
      :social-mode="socialMode"
      :social-mode-ratio="0.5"
      hide-legend />
    <p class="text-muted mt-2 small text-right">Source: Pandora Papers data</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartUsaTopFiveTrusts'
}
</script>

<tsv>
label	value
South Dakota	81
Florida	37
Delaware	35
Texas	24
Nevada	14
</tsv>
